'use client'
import Image from 'next/image'
import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { useTranslations } from 'next-intl'
const EthicsAccordionLayout = ({ title, content , accordionNo}) => {
  const t = useTranslations('ethics-and-compliance-page')
  const [isExpanded, setIsExpanded] = useState(false)
  const handleToggleAccordion = () => {
    setIsExpanded(!isExpanded)
  }
  return (
    <div className='leading-[1.5] text-[18px] md:text-[16px]'>
      <div
        onClick={handleToggleAccordion}
        className={`py-4 mb-2 px-6 cursor-pointer text-[28px] border-t border-[rgba(139,149,158,.5019607843)]  duration-300 ease-in-out transition-colors flex items-center justify-between`}
      >
        <p className='font-light '>{`${accordionNo}. ${t(`accordion.${title}.title`)}`}</p>
        <span
          className={`accordion-arrow ${isExpanded ? 'rotate-180' : ''}`}
        />
      </div>
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{
          height: isExpanded ? 'auto' : 0,
          opacity: isExpanded ? 1 : 0,
        }}
        transition={{ duration: 0.2 }}
        className={`overflow-hidden px-6`}
      >
        <div className='mt-6 '>
            {
                content.map(point => {

return(
    <div className='mb-12' key={point}>
        <h5 className='font-normal text-[18px] md:text-[16px] mb-2'>{t(`accordion.${title}.points.${point}.title`)}</h5>
        <p className='font-light leading-[1.6] '>{t(`accordion.${title}.points.${point}.desc`)}</p>
    </div>
)
                })
            }
        </div>
      </motion.div>
    </div>
  )
}

export default EthicsAccordionLayout
